import { queryClient } from "../api/queries/queryClient";

export function prepareAdminBorrowSession(): void {
  localStorage.removeItem("adminBorrow");
  localStorage.removeItem("userData");
  localStorage.removeItem("customerData");
  queryClient.removeQueries({
    predicate: (query) => query.queryKey[0] !== "maintenance",
  });
}
